/**
 * The handful of places the native build differs from the web build.
 *
 * Kept in one file so the difference is auditable rather than scattered
 * through components as `if (isNative)` checks.
 */

declare global {
  interface Window {
    Capacitor?: { isNativePlatform?: () => boolean; getPlatform?: () => string }
  }
}

export function isNative(): boolean {
  return window.Capacitor?.isNativePlatform?.() ?? false
}

export function platform(): 'ios' | 'android' | 'web' {
  const value = window.Capacitor?.getPlatform?.()
  return value === 'ios' || value === 'android' ? value : 'web'
}

/**
 * Where the API lives.
 *
 * The web build is same-origin and uses a cookie. The native build runs from
 * https://localhost inside a WebView, so it needs an absolute origin and a
 * bearer token — a first-party cookie is not available to it.
 */
export function apiOrigin(): string {
  const configured = import.meta.env['VITE_API_URL']
  if (configured) return configured
  if (isNative()) {
    throw new Error('VITE_API_URL must be set for native builds')
  }
  return window.location.origin
}
